import { Sidebar } from 'primeng/sidebar';
import { ZIndexUtils } from 'primeng/utils';

/**
 * PrimeNG 19 p-sidebar ESC handling — two runtime prototype patches applied
 * app-wide from one place (same approach main.ts uses for other library
 * quirks). Remove if PrimeNG fixes the upstream behaviour.
 *
 * 1) `bindDocumentEscapeListener` — fixes a stacked/nested-sidebar bug.
 *    Every open sidebar binds a document `keydown` listener that should close
 *    only when it is the top-most overlay, but PrimeNG's guard is:
 *
 *        parseInt(this.container.style.zIndex) === ZIndexUtils.get(this.container)
 *
 *    `ZIndexUtils.get(el)` returns that element's OWN z-index, so the guard
 *    compares the container to itself and is ALWAYS true — one ESC closes every
 *    open sidebar. We compare against the current TOP of the overlay stack
 *    (`ZIndexUtils.getCurrent()`) so ESC closes only the top-most sidebar.
 *
 * 2) `onAnimationStart` — makes ESC work on EVERY sidebar app-wide.
 *    PrimeNG only binds the ESC listener when `closeOnEscape` is true, so
 *    sidebars declared with `[closeOnEscape]="false"` never respond to ESC.
 *    We bind unconditionally (dropping the `if (this.closeOnEscape)` guard) so
 *    ESC always closes the top-most slider, regardless of that input.
 *    NOTE: this intentionally overrides `[closeOnEscape]="false"` set on
 *    data-entry forms — a stray ESC will now close them.
 */
(Sidebar.prototype as any).bindDocumentEscapeListener = function () {
  const documentTarget = this.el ? this.el.nativeElement.ownerDocument : this.document;
  this.documentEscapeListener = this.renderer.listen(documentTarget, 'keydown', (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      if (this.container && parseInt(this.container.style.zIndex, 10) === ZIndexUtils.getCurrent()) {
        this.close(event);
      }
    }
  });
};

(Sidebar.prototype as any).onAnimationStart = function (event: any) {
  switch (event.toState) {
    case 'visible':
      this.container = event.element;
      this.appendContainer();
      this.show();
      // Always bind ESC (PrimeNG guards this behind `closeOnEscape`); combined
      // with the top-of-stack guard above, ESC closes only the top slider.
      this.bindDocumentEscapeListener();
      break;
  }
};
